// extracted by mini-css-extract-plugin
module.exports = {"container":"rewardHistoryStyles_container__boMPn","clamp2":"rewardHistoryStyles_clamp2__1rHus"};